import React from 'react';
import { Row } from 'reactstrap';
import CommissionsListing from './Finance';
import { useCompanyName } from 'Components/Common/ThemeSettings/themeutitlity';

const Commissions = () => {
    
    document.title = `DTS | ${useCompanyName()}`;

    return (
        <React.Fragment>                        
            <Row>
                <CommissionsListing />
            </Row>
        </React.Fragment>
    );
};

export default Commissions;